import { useContext } from "react";
import { FormControl, Typography, MenuItem, Select } from "@mui/material";
import { classes } from "../classes";

export default function Target({ context }) {
    
    const {
        complaintTarget, setComplaintTarget,
    } = useContext(context);
   
    return (
        <>

            <Typography style={classes.labelInput}>
                Serviço de destino:
            </Typography>
            <FormControl variant='outlined' style={classes.formControl}>
                {/* <Autocomplete
                    popupIcon={<DropdownIcon />}
                    value={complaintTarget}
                    onChange={(e, newValue) => setComplaintTarget(newValue)}
                    onBlur={() => setComplaintTarget(prev => prev || 'Todos')}
                    options={complaintTargetList}
                    disableClearable
                    getOptionLabel={(option) => option}
                    defaultValue={'Todos'}
                    renderInput={(params) => <TextField {...params} />}
                /> */}

                <Select
                    onChange={e => setComplaintTarget(e.target.value)}
                    value={complaintTarget}
                    style={{ 'background': '#fff' }}
                >
                    <MenuItem value="Todos">Todos</MenuItem>
                    <MenuItem value="Cidadão">Cidadão</MenuItem>
                    <MenuItem value="Visão">Visão</MenuItem>
                </Select>
            </FormControl>

        </>
    )
}